import { BASVURU_IADE_KURAL_LISTESI } from "../constants/requestUrls";

import { getRequest } from "../request";

const BasvuruIadeKuralListesi = (basvuruId) => {
  return getRequest({ url: BASVURU_IADE_KURAL_LISTESI + "?basvuruId=" + basvuruId });
}

export default BasvuruIadeKuralListesi;